import { Calendar, CheckSquare, Clock, DollarSign, FileText, Users, HandCoins, Home, BookOpen, WalletCards } from "lucide-react";
import { NavLink, useParams } from "react-router-dom";
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { useEvento } from "@/hooks/useEvento";
import { tipoEventoLabel } from "@/lib/evento-nome";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";

// Função que retorna menu items com URLs completas baseadas no eventoId
const getEventMenuItems = (eventoId: string) => [{
  title: "Resumo do evento",
  url: `/evento/${eventoId}/dashboard`,
  icon: Home
}, {
  title: "Detalhes do evento",
  url: `/evento/${eventoId}/detalhes`,
  icon: FileText
}, {
  title: "Briefing",
  url: `/evento/${eventoId}/briefing`,
  icon: BookOpen
}, {
  title: "Tarefas",
  url: `/evento/${eventoId}/tarefas`,
  icon: CheckSquare
}, {
  title: "Orçamento",
  url: `/evento/${eventoId}/orcamento`,
  icon: DollarSign
}, {
  title: "Fornecedores",
  url: `/evento/${eventoId}/fornecedores`,
  icon: HandCoins
}, {
  title: "Pagamentos",
  url: `/evento/${eventoId}/pagamentos-fornecedores`,
  icon: WalletCards
}, {
  title: "Convidados",
  url: `/evento/${eventoId}/convidados`,
  icon: Users
}, {
  title: "Cronograma",
  url: `/evento/${eventoId}/cronograma`,
  icon: Clock
}, {
  title: "Documentos",
  url: `/evento/${eventoId}/documentos`,
  icon: FileText
}];
export function EventSidebar() {
  const {
    state
  } = useSidebar();
  const {
    id
  } = useParams();
  const isCollapsed = state === "collapsed";

  // Buscar dados reais do evento
  const { evento, loading } = useEvento(id);
  
  // Gerar menu items com o ID do evento
  const eventMenuItems = getEventMenuItems(id || '');
  
  const getNavClassName = ({
    isActive
  }: {
    isActive: boolean;
  }) => isActive ? "bg-primary text-primary-foreground font-medium" : "text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground";
  return <Sidebar className={isCollapsed ? "w-16" : "w-64"} collapsible="icon">
      <SidebarContent>
        {/* Header com informações do evento */}
        <div className="p-3 border-b border-sidebar-border">
          <div className="flex items-center justify-center">
            {!isCollapsed && <div className="text-center">
                {loading ? (
                  <>
                    <Skeleton className="h-4 w-20 mb-1 mx-auto" />
                    <Skeleton className="h-3 w-24 mx-auto" />
                  </>
                ) : (
                  <>
                    <h1 className="font-bold text-sm text-brand-purple font-omnes">
                      {tipoEventoLabel(evento?.tipo_evento)}
                    </h1>
                    <p className="text-xs text-brand-blue font-medium font-omnes">
                      {evento?.nomeCompleto || 'Carregando...'}
                    </p>
                  </>
                )}
              </div>}
          </div>
        </div>

        {/* Botão para voltar aos eventos */}
        <div className="p-2 border-b border-sidebar-border">
          <Button asChild variant="ghost" size="sm" className="w-full justify-start">
            <NavLink to="/eventos" className="flex items-center gap-2">
              <Calendar className="h-4 w-4" />
              {!isCollapsed && <span>Voltar aos Eventos</span>}
            </NavLink>
          </Button>
        </div>

        {/* Menu do Evento - Sempre aberto */}
        <SidebarGroup>
          <SidebarGroupLabel className="text-sidebar-foreground px-2 py-1">
            <span>Gestão do Evento</span>
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {eventMenuItems.map(item => <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink to={item.url} className={getNavClassName}>
                      <item.icon className="h-4 w-4 text-sidebar-foreground" />
                      {!isCollapsed && <span className="text-muted-foreground">{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>)}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

      </SidebarContent>
    </Sidebar>;
}